import { useQuery } from "@tanstack/react-query";
import { create, windowScheduler, keyResolver } from "@yornaath/batshit";
import { SystemCatalog } from "@graylog/server-api";
const ownerTitles = create({
  fetcher: (ids) => SystemCatalog.getTitles({
    entities: ids.flatMap((id) => [
      {
        id,
        type: "users",
        identifier_type: void 0,
        display_template: void 0,
        identifier_field: void 0,
        display_fields: void 0
      },
      {
        id,
        type: "teams",
        identifier_type: void 0,
        display_template: void 0,
        identifier_field: void 0,
        display_fields: void 0
      }
    ])
  }).then(({ entities }) => entities),
  resolver: keyResolver("id"),
  scheduler: windowScheduler(10)
});
const toAssignee = (entity) => {
  if (!(entity == null ? void 0 : entity.title)) {
    return void 0;
  }
  return {
    id: entity.id,
    label: entity.title,
    type: entity.type === "teams" ? "team" : "user"
  };
};
const isAdminOwnerId = (ownerId) => ownerId == null ? void 0 : ownerId.endsWith("admin");
export const fetchOwnerTitle = (ownerId) => isAdminOwnerId(ownerId) ? Promise.resolve({ id: ownerId, label: "Administrator", type: "user" }) : ownerTitles.fetch(ownerId).then((owner) => toAssignee(owner));
export const fetchOwnerTitles = async (ownerIds) => {
  if (!(ownerIds == null ? void 0 : ownerIds.length)) {
    return [];
  }
  const uniqueOwnerIds = Array.from(new Set(ownerIds.filter(Boolean)));
  const entities = await Promise.all(uniqueOwnerIds.map((ownerId) => fetchOwnerTitle(ownerId)));
  return entities.filter(Boolean);
};
const useOwnerAssignee = (ownerId) => {
  const { data, isInitialLoading } = useQuery({
    queryKey: ["security_events", "owner", ownerId],
    queryFn: () => fetchOwnerTitle(ownerId),
    enabled: !!ownerId
  });
  return {
    data,
    isInitialLoading
  };
};
export default useOwnerAssignee;
